import React from "react";
import SVGandTextContainer from "../Sidebar/SVGandTextContainer";
import { squarePlus } from "@/components/icons/SVGIcons";

const EmptyWorkspaceMessage = () => {
  const sidebarOffset = -95;

  return (
    // Must keep z-index of 10 so that it can be clicked above RGL.
    <div
      data-testid="EmptyWorkspaceMessageComponent"
      className="EmptyWorkspaceMessageComponent z-10 flex h-full w-full items-center justify-center"
    >
      <div
        className="block max-w-sm rounded-lg"
        style={{ transform: `translateX(${sidebarOffset}px)` }}
      >
        {/* <div className="text-md mb-2 tracking-tight text-gray-900 dark:text-white">
          It looks like your workspace is empty!
        </div> */}
        <div className="flex flex-col items-center justify-center gap-3  text-gray-700 dark:text-gray-400">
          <span className="plusContainer flex max-w-[45px] rounded-lg border border-gray-700 bg-cubeBase-800 dark:border-gray-400 dark:bg-cubeBaseDark-800 [&>div>div]:!text-gray-700 dark:[&>div>div]:!text-gray-400">
            <SVGandTextContainer
              tooltipID={"widgets"}
              SVGIcon={squarePlus}
              toolbarOpen={false}
              openText={""}
            />
          </span>
          <p className="text-center text-sm">
            <div className="text-lg font-bold">Your Workspace</div>
            Add a Widget to get started
          </p>
        </div>
      </div>
    </div>
  );
};

export default EmptyWorkspaceMessage;
